
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M71.6 44.3s8.9 3.2 12.2 12.5c1.1 3.2 4.6 5.5 8.2 5.5h17.4c4.8 0 8.7-4 8.7-8.7s-4-8.7-8.7-8.7H95.6l19.7-19.7c3.5-3.5 3.5-9 0-12.4-3.5-3.5-8.9-3.5-12.3 0L83 32.6l.2-13.9c0-5.1-3.9-8.6-8.6-8.6-4.8 0-8.7 3.9-8.7 8.6v17.4c0 3.8 2.5 6.8 5.7 8.2zM10 53.5c0 4.8 4 8.8 8.7 8.8h17.4c3.7 0 6.9-2.4 8.2-5.7 0 0 3.1-8.9 12.3-12.2 3.2-1.1 5.5-4.6 5.5-8.2V18.8c0-4.8-3.9-8.7-8.6-8.7-4.9 0-8.7 4-8.7 8.7v13.7l-20-19.9c-3.4-3.5-8.9-3.5-12.3 0s-3.4 8.9 0 12.3L32.6 45l-13.9-.1c-5.5 0-8.7 3.7-8.7 8.6zM74.5 117.9c4.8 0 8.7-3.6 8.7-8.7V95.6l19.8 19.8c3.5 3.5 8.9 3.5 12.3 0 3.5-3.5 3.5-8.9 0-12.3L95.3 83l13.9.2c5.2 0 8.7-3.9 8.7-8.6s-4-8.7-8.7-8.7H91.8c-3.7 0-6.9 2.4-8.2 5.7 0 0-3.1 8.9-12.3 12.2-3.2 1.1-5.6 4.6-5.6 8.2v17.4c.1 4.6 4 8.5 8.8 8.5zM56.4 83.7s-8.9-3.1-12-12.4c-1.2-3.2-4.6-5.5-8.2-5.5H18.9c-4.9 0-8.7 4-8.7 8.7 0 4.7 3.9 8.7 8.7 8.7h13.5l-19.7 19.9c-3.5 3.2-3.5 8.9 0 12.3 3.2 3.5 8.9 3.5 12.3 0l20.1-20.1-.2 13.9c-.2 5.5 3.7 8.6 8.4 8.6 4.9 0 8.7-3.9 8.7-8.6V91.9c.1-3.9-2.2-7-5.6-8.2z"}})])
          )
        }
      }
    